import React, { CSSProperties } from 'react';
import emptyPng from './res/empty.png';

interface EmptyProps {
  message: string;
  style?: CSSProperties;
}

export function Empty(props: EmptyProps) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...props.style,
        // background: 'rgba(245,245,245,1)'
      }}>
      <div style={{ fontSize: '20px', color: '#4A4A4A', textAlign: 'center' }}>
        <img src={emptyPng} />
        <div style={{ marginTop: '51px' }}>{props.message}</div>
      </div>
    </div>
  );
}
